import React, { useEffect, useState } from "react";

const VIDEO_DETAILS = {
  videoSrc: process.env.PUBLIC_URL + "/videos/FirstSlide-1.mp4",
  placeholderImage: "/images/Home/HomeBanner/banner-1.png",
};

export default function HeroVideo() {
  const [objectFit, setObjectFit] = useState("cover");
  // New state to manage the container's aspect ratio/height
  const [useAspectRatio, setUseAspectRatio] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      
      // Hybrid behavior:
      if (width <= 1800) {
        setObjectFit("contain");
        setUseAspectRatio(true); 
      } else {
        // For large screens: Use 'cover' to fill the screen
        setObjectFit("cover");
        setUseAspectRatio(false); 
      }
    };
    
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Base styles for the hero container
  const baseHeroStyles = {
    position: "relative",
    width: "100%",
    overflow: "hidden",
    backgroundColor: "#fdf9f9ff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  
  // Dynamic container styles to adjust height/aspect-ratio
  const heroContainerStyles = useAspectRatio
    ? { 
        ...baseHeroStyles, 
        aspectRatio: "16 / 9", 
        height: "auto", // Let the aspect-ratio dictate the height
      }
    : {
        ...baseHeroStyles, 
        // When using 'cover' on large screens, use 100vh height
        height: "100vh",
      };


  const styles = {
    hero: heroContainerStyles, // Use the new dynamic styles
    videoElement: {
      width: "100%",
      height: "100%",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 1,
      objectFit: objectFit,
      objectPosition: "center",
      backgroundColor: "#fcf7f7ff",
      filter: "brightness(1.1) contrast(1.05)",
    },
  };

  return (
    <div style={styles.hero}>
      <video
        style={styles.videoElement}
        autoPlay
        loop
        muted
        playsInline
        preload="auto"
        poster={VIDEO_DETAILS.placeholderImage}
      >
        <source src={VIDEO_DETAILS.videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}